import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close_popup",
  "use": "close_popup-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"close_popup\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.788 7.658a.727.727 0 0 1-1.027 0L4.063 4.963 1.239 7.786A.726.726 0 0 1 .212 6.76l2.824-2.826L.34 1.24A.726.726 0 0 1 1.367.212l2.696 2.696L6.631.342A.726.726 0 1 1 7.66 1.368L5.09 3.934l2.697 2.698a.726.726 0 0 1 0 1.026z\" fill=\"#27AE60\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol